import { View } from '@react-pdf/renderer';
import IconCircle from '@components/MbtiPdfReporterMobile/components/IconCircle';
import TextWithBlank from '@components/PdfReporter/components/TextWithBlank';
import { usePdfType } from '@components/MbtiPdfReporterMobile/utils/styles';

function ScoreTitle(props: { color: string; title: string; style?: any }) {
    const pdfType = usePdfType();
    const { color, title, style } = props;

    return (
        <View style={{ justifyContent: 'flex-start', flexDirection: 'row', ...style }}>
            <View
                style={{
                    width: 18,
                    height: 18,
                    marginRight: 6,
                    position: 'relative',
                    top: 1,
                    left: 2,
                    ...(pdfType === 'ms' ? { width: 14, height: 14, top: 3 } : {}),
                }}
            >
                <IconCircle stroke={color} />
            </View>
            <TextWithBlank style={{ fontSize: 16, letterSpacing: -1.7 }}>{title}</TextWithBlank>
        </View>
    );
}

export default ScoreTitle;
